import { Flex, Image } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconAssets } from 'src/config';

interface IDetailsButton {
	opened: boolean;
	open: () => void;
}

export const DetailsButton: FC<IDetailsButton> = ({ opened, open }) => {
	const { t } = useTranslation();

	return (
		<Flex
			onClick={open}
			cursor="pointer"
			opacity={opened ? '1' : '1'}
			_hover={{ opacity: '1' }}
			borderRadius="4px"
			gridGap="10px"
			fontSize="12px"
			fontWeight="bold"
			alignItems="center"
			padding="13px"
			bg={opened ? '#131313' : '#1D1D1D'}
			textTransform="uppercase"
		>
			{opened ? t('yourGames.columns.close') : t('yourGames.columns.details')}
			{opened ? (
				<Image
					h="6px"
					src={IconAssets.chevronUp}
				/>
			) : (
				<Image
					h="6px"
					src={IconAssets.chevronDown}
				/>
			)}
		</Flex>
	);
};
